import React from 'react';

const ReviewsLayout = (props) => {
	return <div className="app">{props.children}</div>;
};

export default ReviewsLayout;
